import { PlayerSizesTypes } from '../../../common/store/store.types';
import { DISCOVERY_SKIPPABLE_CONTENT_BOTTOM } from '../discoveryPlugin.constants';
import {
  CONTROLS_BAR_HEIGHT,
  MORE_VIDEOS_EXTRA_LARGE_HEIGHT,
  MORE_VIDEOS_LARGE_HEIGHT,
} from '../../../common/utils/common.constants';

interface StylesObject {
  skippableContentContainerStyle: {
    hide: { [key: string]: any }; small: { [key: string]: any };
    medium: { [key: string]: any }; large: { [key: string]: any }; extraLarge: { [key: string]: any }
  } & any;
}

interface SkippableContentContainerStyleObject {
  root: { [key: string]: any };
  hide: { [key: string]: any };
  smallSkippableContent: { [key: string]: any };
  small: { [key: string]: any };
  largeAndExtraLarge: { [key: string]: any };
}

const skippableContentContainer = (showGalleryView: boolean, playerSize: PlayerSizesTypes): SkippableContentContainerStyleObject => {
  const galleryExtraHeight = showGalleryView && (playerSize === 'large' ? MORE_VIDEOS_LARGE_HEIGHT : MORE_VIDEOS_EXTRA_LARGE_HEIGHT);
  return {
    root: {
      pointerEvents: 'auto',
      display: 'block',
      right: '0',
      position: 'absolute',
      width: '165px',
      height: '158px',
      bottom: `${CONTROLS_BAR_HEIGHT + DISCOVERY_SKIPPABLE_CONTENT_BOTTOM}px`,
    },
    hide: {
      display: 'none',
    },
    smallSkippableContent: {
      width: '101px',
      height: '60px',
    },
    small: {
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      position: 'unset',
      right: 'unset',
      bottom: 'unset',
    },
    largeAndExtraLarge: {
      bottom: `${CONTROLS_BAR_HEIGHT + galleryExtraHeight + DISCOVERY_SKIPPABLE_CONTENT_BOTTOM}px`,
    },
  };
};

export const getSkippableContentStyleObject = (playerSize: PlayerSizesTypes, showSkippableContent: boolean, smallSkippableContent: boolean, showGalleryView: boolean): StylesObject => {
  const smallSize = playerSize === 'small';
  const largeOrExtraLargeSize = playerSize === 'large' || playerSize === 'extraLarge';
  const skippableContainerStyleObject = skippableContentContainer(showGalleryView, playerSize);

  return ({
    skippableContentContainerStyle: [
      skippableContainerStyleObject.root,
      smallSkippableContent && skippableContainerStyleObject.smallSkippableContent,
      smallSize && skippableContainerStyleObject.small,
      largeOrExtraLargeSize && skippableContainerStyleObject.largeAndExtraLarge,
      !showSkippableContent && skippableContainerStyleObject.hide,
    ],
  });
};
